export function dataAnonymizer(obj: any, keyList: string[]): any {
  if (typeof obj !== 'object') return obj

  const keysToAnonymizeSet = new Set(keyList)

  const filteredProperties: any = {}
  for (const key in obj) {
    const value = obj[key]
    if (typeof value === 'object') {
      filteredProperties[key] = dataAnonymizer(value, keyList)
      continue
    }

    if (keysToAnonymizeSet.has(key)) {
      if (typeof value === 'string') filteredProperties[key] = '****'
      if (typeof value === 'number') filteredProperties[key] = 0
    } else {
      filteredProperties[key] = value
    }
  }
  return filteredProperties
}
